import api from '../utils/axios';
import type { QueueState } from '../types/queue';

/**
 * Fetch the current queue state for a project.
 * Returns jobs in statuses: CURRENT, QUEUED, PAUSED, WAITING_FOR_APPROVAL, FAILED, STOPPED.
 */
export async function getQueueState(projectId: string): Promise<QueueState> {
  const response = await api.get(`/dev-agent/projects/${projectId}/queue`);
  return response.data as QueueState;
}

/**
 * Update a queued job's message text, settings, and model (saved when the user clicks "Save Changes").
 * Editing is local-only (client-side) — it never sets a blocking intervention on the server.
 */
export async function updateQueueJob(
  projectId: string,
  jobId: string,
  payload: {
    user_message?: string;
    settings?: Record<string, boolean>;
    model_preference?: string;
    interaction_mode?: string;
    file_ids?: string[];
    artifact_ids?: string[];
    image_ids?: string[];
    attachments?: any[];
  }
): Promise<void> {
  await api.patch(`/dev-agent/projects/${projectId}/queue/${jobId}`, payload);
}

/**
 * Cancel a queued job. Sets status to CANCELLED (soft-delete).
 */
export async function cancelQueueJob(
  projectId: string,
  jobId: string
): Promise<void> {
  await api.delete(`/dev-agent/projects/${projectId}/queue/${jobId}`);
}

/**
 * Resumes all PAUSED jobs back to QUEUED status.
 */
export async function resumeAllQueueJobs(
  projectId: string
): Promise<{ status: string; resumed_count: number }> {
  const response = await api.post(`/dev-agent/projects/${projectId}/queue/resume-all`);
  return response.data;
}
